import React from 'react';
import { SubmitButton } from './table-select-filter-components';
import { Link } from '@cloudscape-design/components';
import { createTableSortLabelFn } from '../../i18n-strings';
import { parseAiRecommendationPercentageScore } from '../../common/utility'

const createRawColumns = (onSubmissionComplete) => [
  {
    id: 'id',
    header: 'Submission ID',
    cell: item => {
      if (!item.is_submitted) {
      
        return  <Link href={`/application-details/${item.id}`}>Submission-{item.id}</Link>;
      }
      else{
      return <>Submission-{item.id}</>;
      }
    },
    headerStyle: {
      backgroundColor: '#2196F3',
      color: '#FFFFFF'
    }
  },
  {
    id: 'framework_title',
    header: 'Framework',
    cell: item => item.framework.title,
  },
  {
    id: 'created',
    header: 'Created',
    cell: item => {
      const date = new Date(item.created);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
  },
  {
    id: 'summary',
    header: 'Summary',
    cell: item => <Link href={`/application-summary/${item.id}`}>Summary</Link>,
  },
  {
    id: 'score',
    header: 'Score',
    cell: item =>  item.avg_score ? `${parseAiRecommendationPercentageScore(item.avg_score)}%` : "n/a",
  },
  {
    id: 'submit',
    header: 'Submit',
    cell: item => <SubmitButton item={item} onSubmissionComplete={onSubmissionComplete} />,
  },
];

export const createColumnDefinitions = (onSubmissionComplete) => {
  const rawColumns = createRawColumns(onSubmissionComplete);
  return rawColumns.map(column => ({ 
    ...column, 
    ariaLabel: createTableSortLabelFn(column) 
  }));
};

// Default column definitions without callback (for backward compatibility)
const rawColumns = createRawColumns(null);
export const COLUMN_DEFINITIONS = rawColumns.map(column => ({ 
  ...column, 
  ariaLabel: createTableSortLabelFn(column) 
}));
